import { Routes, Route } from "react-router-dom";
import Header from "./components/App/Header";
import Home from "./components/Pages/Home";
import RequireAuth from "./components/AuthGuard/RequireAuth";
import { useState, useEffect } from "react";
import { GlobalStateProvider } from "./components/Context/GlobalStateContext";
import Scorecard from "./components/Pages/scorecard";
import Exceptions from "./components/Pages/Exceptions";
import Comm from "./components/Pages/Comm";
import COPA from "./components/Pages/COPA";
import ProgramList from "./components/Pages/ProgramList";
import GroupList from "./components/Pages/GroupList";
import AddGroup from "./components/Pages/AddGroup";
import ProgramDashboard from "./components/Pages/ProgramDashboard";
import BulkInput from "./components/Pages/BulkInput";
import ApprovalSettings from "./components/Pages/ApprovalSettings";
import IBBRequiredApproval from "./components/Pages/IBBRequiredApproval";
import InvoicesData from "./components/Pages/InvoicesData";
import COPAInvoicesData from "./components/Pages/COPAInvoicesData";
import CreditNotesData from "./components/Pages/CreditNotesData";
import CreditNotesApproval from "./components/Pages/CreditNotesApproval";
import PFIEmailTemplate from "./components/Pages/PFIEmailTemplate";
import ReInvestmentData from "./components/Pages/ReInvestmentData";
import ReInvestmentsApproval from "./components/Pages/ReInvestmentsApproval";
import ProgramApproval from "./components/Pages/ProgramApproval";
import ProgramImporterFormulaSelection from "./components/Pages/ProgramImporterFormulaSelection";
import IBBDepartment from "./components/Pages/IBBDepartment";
import IBBPaymentCriteria from "./components/Pages/IBBPaymentCriteria";
import { SignaturePad } from "./components/Pages/SignaturePad";
import ImporterSettings from "./components/Pages/ImporterSettings";
import ConditionalHoldApproval from "./components/Pages/ConditionalHoldApproval";
import ExceptionHistory from "./components/Pages/ExceptionHistory";
import ConditionalHoldHistory from "./components/Pages/ConditionalHoldHistory";
import RequireAuthJLR from "./components/AuthGuard/RequireAuthJLR";
import AccessLevel from "./components/Pages/AccessLevel";
import { TestCharts } from "./components/Pages/TestCharts";
import DeadlineManagement from "./components/Pages/DeadlineManagement";
import ProgramDashboardV2 from "./components/Pages/ProgramDashboardV2";
import { Dragdroptest } from "./components/Pages/Dragdroptest";
import Triggers from "./components/Pages/Triggers";
import { Dashboard } from "./components/Pages/Dashboard";
import AccessDenied from "./components/Pages/AccessDenied";
import { NotificationsScreen } from "./components/Pages/NotificationsScreen";
import AchievementStatusReport from "./components/Pages/AchievementStatusReport";
import ProgramStatus from "./components/Pages/programstatus";
import { ProgramOverview } from "./components/Pages/ProgramOverview";

function App() {
  return (
    <main>
      <GlobalStateProvider>
        <div className="App--main">
          <Header />
          <div className="Body--Main">
            <Routes>
              <Route
                path=""
                element={
                  <RequireAuth>
                    <ProgramDashboardV2 />
                  </RequireAuth>
                }
              />
              <Route
                path="home"
                element={
                  <RequireAuth>
                    <Home />
                  </RequireAuth>
                }
              />
              <Route
                path="scorecard"
                element={
                  <RequireAuth>
                    <Scorecard />
                  </RequireAuth>
                }
              />
              <Route
                path="signaturepad"
                element={
                  <RequireAuth>
                    <SignaturePad />
                  </RequireAuth>
                }
              />
              <Route
                path="TestCharts"
                element={
                  <RequireAuth>
                    <TestCharts />
                  </RequireAuth>
                }
              />
              <Route
                path="programoverview"
                element={
                  <RequireAuth>
                    <ProgramOverview />
                  </RequireAuth>
                }
              />
              <Route
                path="exceptions"
                element={
                  <RequireAuth>
                    <Exceptions />
                  </RequireAuth>
                }
              />
              <Route
                path="programlist"
                element={
                  <RequireAuth>
                    <ProgramList />
                  </RequireAuth>
                }
              />
              <Route
                path="copa"
                element={
                  <RequireAuth>
                    <COPA />
                  </RequireAuth>
                }
              />
              <Route
                path="grouplist"
                element={
                  <RequireAuth>
                    <GroupList />
                  </RequireAuth>
                }
              />
              <Route
                path="addgroup"
                element={
                  <RequireAuth>
                    <AddGroup />
                  </RequireAuth>
                }
              />
              <Route
                path="programdashboard"
                element={
                  <RequireAuth>
                    <ProgramDashboardV2 />
                  </RequireAuth>
                }
              />
              <Route
                path="programdashboardv2"
                element={
                  <RequireAuth>
                    <ProgramDashboardV2 />
                  </RequireAuth>
                }
              />
              <Route
                path="bulkinput"
                element={
                  <RequireAuth>
                    <BulkInput />
                  </RequireAuth>
                }
              />
              <Route
                path="approvalsettings"
                element={
                  <RequireAuth>
                    <ApprovalSettings />
                  </RequireAuth>
                }
              />
              <Route
                path="ibbrequiredapproval"
                element={
                  <RequireAuth>
                    <IBBRequiredApproval />
                  </RequireAuth>
                }
              />
              <Route
                path="invoicesdata"
                element={
                  <RequireAuth>
                    <InvoicesData />
                  </RequireAuth>
                }
              />
              <Route
                path="copainvoicesdata"
                element={
                  <RequireAuth>
                    <COPAInvoicesData />
                  </RequireAuth>
                }
              />
              <Route
                path="creditnotesdata"
                element={
                  <RequireAuth>
                    <CreditNotesData />
                  </RequireAuth>
                }
              />
              <Route
                path="creditnotesapproval"
                element={
                  <RequireAuth>
                    <CreditNotesApproval />
                  </RequireAuth>
                }
              />
              <Route
                path="emailtemplates"
                element={
                  <RequireAuth>
                    <PFIEmailTemplate />
                  </RequireAuth>
                }
              />
              <Route
                path="reinvestment"
                element={
                  <RequireAuth>
                    <ReInvestmentData />
                  </RequireAuth>
                }
              />
              <Route
                path="reinvestmentapproval"
                element={
                  <RequireAuth>
                    <ReInvestmentsApproval />
                  </RequireAuth>
                }
              />
              <Route
                path="programapproval"
                element={
                  <RequireAuth>
                    <ProgramApproval />
                  </RequireAuth>
                }
              />
              <Route
                path="ibbformulaselection"
                element={
                  <RequireAuth>
                    <ProgramImporterFormulaSelection />
                  </RequireAuth>
                }
              />
              <Route
                path="functionalarea"
                element={
                  <RequireAuth>
                    <IBBDepartment />
                  </RequireAuth>
                }
              />
              <Route
                path="importersettings"
                element={
                  <RequireAuth>
                    <ImporterSettings />
                  </RequireAuth>
                }
              />
              <Route
                path="paymentcriteria"
                element={
                  <RequireAuth>
                    <IBBPaymentCriteria />
                  </RequireAuth>
                }
              />
              <Route
                path="conditionalholdapproval"
                element={
                  <RequireAuth>
                    <ConditionalHoldApproval />
                  </RequireAuth>
                }
              />
              <Route
                path="exceptionhistory"
                element={
                  <RequireAuth>
                    <ExceptionHistory />
                  </RequireAuth>
                }
              />
              <Route
                path="conditionalholdhistory"
                element={
                  <RequireAuth>
                    <ConditionalHoldHistory />
                  </RequireAuth>
                }
              />
              <Route
                path="useraccesslevel"
                element={
                  <RequireAuth>
                    <AccessLevel />
                  </RequireAuth>
                }
              />
              <Route
                path="deadlinemanagement"
                element={
                  <RequireAuth>
                    <DeadlineManagement />
                  </RequireAuth>
                }
              />
              <Route
                path="triggers"
                element={
                  <RequireAuth>
                    <Triggers />
                  </RequireAuth>
                }
              />
              <Route
                path="dragdroptest"
                element={
                  <RequireAuth>
                    <Dragdroptest />
                  </RequireAuth>
                }
              />

              <Route
                path="accessdenied"
                element={
                  <RequireAuth>
                    <AccessDenied />
                  </RequireAuth>
                }
              />

              <Route
                path="mynotifications"
                element={
                  <RequireAuth>
                    <NotificationsScreen />
                  </RequireAuth>
                }
              />

              <Route
                path="achievementstatusreport"
                element={
                  <RequireAuth>
                    <AchievementStatusReport />
                  </RequireAuth>
                }
              />

              <Route
                path="programstatus"
                element={
                  <RequireAuth>
                    <ProgramStatus />
                  </RequireAuth>
                }
              />

              <Route
                path="programoverviewv2"
                element={
                  <RequireAuth>
                    <ProgramOverview />
                  </RequireAuth>
                }
              />
            </Routes>
          </div>
        </div>
      </GlobalStateProvider>
    </main>
  );
}

export default App;
